import { render, staticRenderFns } from "./AboutFooter.vue?vue&type=template&id=59b91ef3&scoped=true&"
import script from "./AboutFooter.vue?vue&type=script&lang=js&"
export * from "./AboutFooter.vue?vue&type=script&lang=js&"
import style0 from "./AboutFooter.vue?vue&type=style&index=0&id=59b91ef3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b91ef3",
  null
  
)

export default component.exports